import { render, staticRenderFns } from "./DialogRemoveGroup.vue?vue&type=template&id=00786dc5&scoped=true"
import script from "./DialogRemoveGroup.js?vue&type=script&lang=js&external"
export * from "./DialogRemoveGroup.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00786dc5",
  null
  
)

export default component.exports